<template>

    <div>

        <app-head :title="supplier.name" />

        <div class="text-dark p-5 position-relative" style="background: #fffefc;">
            <div class="container">
                <div class="row align-items-center g-5">
                    <div class="col-md-5">
                        <img src="/suppliers/camlog/camlog1.jpg" alt="camlog" loading="lazy" class="img-fluid">
                    </div>
                    <div class="col-md-7">
                        <h1 class="display-3">
                            {{ supplier.name }}
                        </h1>
                        <hr class="my-4">
                        <div class="fs-5 lh-lg" v-html="supplier.description">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container my-5">
        </div>

        <div class="container">

            <div class="row">

                <div class="col-lg-8">

                    <results :total="products.meta.total" :from="products.meta.from" :to="products.meta.to" :filters="filters" />

                    <product-list :products="products.data" max-per-row="4" />

                    <pagination :links="products.meta.links" />

                </div>

                <div class="col-lg-4">

                    <supplier-details
                        :supplier="supplier"
                        :is-favorite-supplier="isFavoriteSupplier"
                        />

                </div>

            </div>

        </div>

    </div>

</template>

<script>
    import Results from '@/shared/Results';
    import Filters from '@/shared/Filters';
    import Pagination from '@/shared/Pagination';
    import Breadcrumbs from '@/shared/Breadcrumbs';
    import ProductList from '@/shared/ProductList';

    import SupplierDetails from './SupplierDetails';

    export default {
        props: [
            'filters',
            'supplier',
            'products',
            'isFavoriteSupplier',
        ],
        components: {
            Results,
            Filters,
            Pagination,
            Breadcrumbs,
            ProductList,
            SupplierDetails,
        }
    }
</script>